(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.profile', {
                url: '/profile',
                templateUrl: 'app/components/profile/profile.view.html',
                controller: 'ProfileController',
                controllerAs: 'vm'
            })
            .state('accountManagement.profileEdit', {
                url: '/profile/{id:int}',
                templateUrl: 'app/components/profile/profile.view.html',
                controller: 'ProfileController',
                controllerAs: 'vm'
            });
    }
})();
